import { computed, ref } from 'vue'
import type { HMSPreviewConfig } from '@100mslive/hms-video-store'
import { HMSReactiveStore } from '@100mslive/hms-video-store'
import type IVisitVideoConference from '@shared/api/visits/resources/admin/visit-video-conference'
import { EInterval } from '@/shared/types/enums'

const previewConfig = ref<HMSPreviewConfig>()
const isShownMeetingRoom = ref<boolean>(false)
const visitId = ref<string | string[]>()
const patientName = ref<string>()
const videoConference = ref<IVisitVideoConference | null>(null)
const isPinPMode = ref<boolean>(false)
const hmsManager = new HMSReactiveStore()
const hmsActions = hmsManager.getActions()
const guestToken = ref<string>()
const countdownInterval = ref<number>(EInterval.URGENT)
const joinVisitCountdownText = computed(() => {
  if (countdownInterval.value > 0) {
    return `Joining Visit in ${countdownInterval.value / 1000} second${countdownInterval.value > 1000 ? 's' : ''}`
  } else {
    return 'Joining Visit Now'
  }
})

export const useComposition = () => {
  return {
    previewConfig,
    isShownMeetingRoom,
    hmsManager,
    hmsActions,
    isPinPMode,
    visitId,
    patientName,
    videoConference,
    guestToken,
    countdownInterval,
    joinVisitCountdownText,
  }
}
